import {Cloud, Github} from 'lucide-react'

function Header() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#070B14]/75 border-b border-[#1F2A44]/60">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-14 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="relative w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-400 to-emerald-400 flex items-center justify-center shadow-[0_0_24px_-4px_rgba(56,225,255,0.5)]">
            <Cloud className="w-4 h-4 text-[#070B14]" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="text-[14px] font-bold tracking-tight text-slate-100">CloudCalculators</div>
            <div className="text-[9px] font-mono uppercase tracking-[0.2em] text-slate-500">multi-cloud · finops</div>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-7 text-[12.5px] text-slate-400">
          <a href="#calculator" className="hover:text-slate-100 transition-colors">Calculator</a>
          <a href="#dashboard" className="hover:text-slate-100 transition-colors">Comparison</a>
          <a href="#hub" className="hover:text-slate-100 transition-colors">Strategy Hub</a>
          <a href="#cta" className="hover:text-slate-100 transition-colors">Enterprise</a>
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#"
            className="hidden sm:inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#1F2A44] hover:border-cyan-500/30 text-slate-400 hover:text-cyan-300 transition-colors"
          >
            <Github className="w-3.5 h-3.5" />
          </a>
          <a
            href="#cta"
            className="text-[12px] font-semibold text-[#070B14] bg-gradient-to-r from-cyan-300 to-emerald-300 hover:from-cyan-200 hover:to-emerald-200 rounded-lg px-3.5 py-1.5 transition-all"
          >
            Get alerts
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
